import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
        label: '车牌号牌',
        prop: 'plateCode',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '车辆类型',
        prop: 'plateCode',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: 'center',
      },
      {
        label: '通道名称',
        prop: 'deviceName',
        // search: true,
        multiple: true,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '出入场类型',
        prop: 'trafficType',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        formatter: function (row, value) {
          return value == 1 ? '入场' : '出场'
        }
      },
      {
        label: '通行时间',
        prop: 'trafficTime',
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        // searchSlot: true,
        align: 'right',
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '通行时间',
        prop: 'passageTime',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        // searchSlot: true,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        hide: true,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      // {
      //   label: '执行结果',
      //   prop: 'plateCode',
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center',
      // },
      // {
      //   label: '执行方式',
      //   prop: 'plateCode',
      //   search: true,
      //   type: 'select',
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center',
      //   dicData: [{
      //     label: '自动抬杆',
      //     value: 1
      //   }, {
      //     label: '人工抬杆',
      //     value: 2
      //   }]
      // },

      {
        label: '车辆图片',
        prop: 'trafficFileCode',
        hide: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        align: 'center',
      },

      {
        label: '设备名称',
        prop: 'deviceName',
        hide: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '电话号码',
        prop: 'phone',
        search: false,
        hide: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        align: 'center'
      },

    ]
  }
}